function formatPrice(raw) {
  const num = String(raw).replace(/[^0-9]/g, '');
  return num ? Number(num).toLocaleString('ja-JP') : raw;
}

const db = window.WWJF_DB || {};

// ヘッダー側からも、このページの商品データを参照可能にする
window.db = Object.assign(window.db || {}, db);

// お気に入りIDをヘッダーと共通化
if (!(window.wishlist instanceof Set)) {
  let savedIds = [];

  try {
    const parsed = JSON.parse(
      localStorage.getItem('wwjf_wishlist') || '[]'
    );

    if (Array.isArray(parsed)) {
      savedIds = parsed;
    }
  } catch (e) {}

  window.wishlist = new Set(savedIds);
}

const wishlist = window.wishlist;

// 別ページで保存した商品データを読み込む
try {
  const savedData = JSON.parse(
    localStorage.getItem('wwjf_wishlist_data') || '{}'
  );

  window.wishlistData = Object.assign(
    {},
    savedData && typeof savedData === 'object' && !Array.isArray(savedData)
      ? savedData
      : {},
    window.wishlistData || {}
  );
} catch (e) {
  window.wishlistData = window.wishlistData || {};
}

// 既存のお気に入りも、今のページにある商品は補完する
wishlist.forEach(id => {
  const item = db[id] || window.db[id];

  if (item) {
    window.wishlistData[id] = item;
  }
});

try {
  localStorage.setItem(
    'wwjf_wishlist_data',
    JSON.stringify(window.wishlistData)
  );
} catch (e) {
  console.warn('[WWJF] お気に入りの商品データを保存できませんでした', e);
}

let currentModalId = null;

let currentCategory = 'WATCH';
let currentBrand = 'ALL';
let currentStatus = 'ALL';
let currentPage = 0;
const PAGE_SIZE = 20;
let currentItems = [];

// ★ scrollObserverを先に定義
const scrollObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      scrollObserver.unobserve(entry.target);
      loadMoreItems();
    }
  });
}, { rootMargin: '200px' });

// スクロールでフェードイン
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

// 初期表示
updateBrandFilterUI();
updateStatusFilterUI();
renderCatalogGrid();

// URLパラメータ処理（renderCatalogGrid()の後）
(function() {
  const params = new URLSearchParams(window.location.search);
  const paramCategory = params.get('category');
  const paramBrand = params.get('brand');
  if (paramCategory) selectCategory(paramCategory);
  if (paramBrand) {
    const catalogProducts = window.WWJF_CATALOG_PRODUCTS || [];
    const matched = catalogProducts.find(p => p.brand === paramBrand)
      || catalogProducts.find(p => p.brand.includes(paramBrand));
    selectBrandOption(matched ? matched.brand : paramBrand);
  }
})();

function scrollToSection(id) { document.getElementById(id).scrollIntoView({ behavior: 'smooth' }); }
function filterAndScroll(category) { scrollToSection('catalog-section'); selectCategory(category); }

function selectCategory(category, btnEl) {
  currentCategory = category;
  currentBrand = 'ALL';
  currentStatus = 'ALL';
  document.querySelectorAll('#categoryTabs .category-tab').forEach(t => t.classList.remove('is-active'));
  const target = btnEl || document.querySelector(`#categoryTabs .category-tab[data-category="${category}"]`);
  if (target) target.classList.add('is-active');
  if (category === 'JEWELRY') {
    document.getElementById('brandSheetTitle').innerText = 'ジュエリーブランドで絞り込む';
  } else {
    document.getElementById('brandSheetTitle').innerText = '時計ブランドで絞り込む';
  }
  const filterBar = document.getElementById('brandFilterBar');
  if (filterBar) filterBar.style.display = (category === 'BAG' || category === 'FRAGRANCE' || category === 'CHAMPAGNE') ? 'none' : 'flex';
  updateBrandFilterUI();
  updateStatusFilterUI();
  renderCatalogGrid();
}

function openBrandSheet() {
  renderBrandSheetList();
  const overlay = document.getElementById('brandSheetOverlay');
  const panel = document.getElementById('brandSheetPanel');
  overlay.classList.add('is-open');
  void overlay.offsetWidth;
  panel.classList.add('is-open');
}

function closeBrandSheet() {
  const overlay = document.getElementById('brandSheetOverlay');
  const panel = document.getElementById('brandSheetPanel');
  panel.classList.remove('is-open');
  setTimeout(() => overlay.classList.remove('is-open'), 300);
}

function renderBrandSheetList() {
  const catalogProducts = window.WWJF_CATALOG_PRODUCTS || [];
  const brands = [
    ...new Set(
      catalogProducts
        .filter(p => p.category === currentCategory)
        .map(p => p.brand)
    )
  ].sort();

  const list = document.getElementById('brandSheetList');
  if (!list) return;

  list.innerHTML = '';

  const appendBrandOption = (brand, label) => {
    const option = document.createElement('div');
    option.className = `brand-option ${
      currentBrand === brand ? 'is-selected' : ''
    }`;

    const radio = document.createElement('span');
    radio.className = 'brand-option__radio';

    const text = document.createElement('span');
    text.textContent = label;

    option.append(radio, text);
    option.addEventListener('click', () => {
      selectBrandOption(brand);
    });

    list.appendChild(option);
  };

  appendBrandOption('ALL', 'すべてのブランド');
  brands.forEach(brand => appendBrandOption(brand, brand));
}


function selectBrandOption(brand) {
  currentBrand = brand;
  closeBrandSheet();
  updateBrandFilterUI();
  updateStatusFilterUI();
  renderCatalogGrid();
}

function updateBrandFilterUI() {
  const trigger = document.getElementById('brandFilterTrigger');
  const tagWrap = document.getElementById('brandFilterTags');
  const brandTitleEl = document.querySelector('.brand-title');

  if (currentBrand === 'ALL') {
    if (trigger) {
      trigger.classList.remove('is-active');
      trigger.querySelector('span').innerText = 'SELECT BRAND';
    }

    if (tagWrap) tagWrap.innerHTML = '';

    if (brandTitleEl) {
      brandTitleEl.innerText = currentCategory + ' 商品一覧';
    }
  } else {
    if (trigger) {
      trigger.classList.add('is-active');
      trigger.querySelector('span').innerText = currentBrand;
    }

    if (tagWrap) {
      tagWrap.innerHTML =
        `<span class="brand-filter-tag">${currentBrand}<button onclick="selectBrandOption('ALL')">&times;</button></span>`;
    }

    if (brandTitleEl) {
      brandTitleEl.innerText = currentBrand;
    }
  }
}

function openStatusSheet() {
  renderStatusSheetList();
  const overlay = document.getElementById('statusSheetOverlay');
  const panel = document.getElementById('statusSheetPanel');
  if (!overlay || !panel) return;
  overlay.classList.add('is-open');
  void overlay.offsetWidth;
  panel.classList.add('is-open');
}

function closeStatusSheet() {
  const overlay = document.getElementById('statusSheetOverlay');
  const panel = document.getElementById('statusSheetPanel');
  if (!overlay || !panel) return;
  panel.classList.remove('is-open');
  setTimeout(() => overlay.classList.remove('is-open'), 300);
}

function renderStatusSheetList() {
  const list = document.getElementById('statusSheetList');
  if (!list) return;
  const options = [{ value: 'ALL', label: 'すべて' }, { value: 'NEW', label: '新作' }, { value: 'LIMITED', label: '限定' }];
  list.innerHTML = options.map(o => `<div class="status-option ${currentStatus === o.value ? 'is-selected' : ''}" onclick="selectStatusFilter('${o.value}')"><span class="status-option__radio"></span><span>${o.label}</span></div>`).join('');
}

function selectStatusFilter(status) {
  currentStatus = status;
  closeStatusSheet();
  updateStatusFilterUI();
  renderCatalogGrid();
}

function updateStatusFilterUI() {
  const trigger = document.getElementById('statusFilterTrigger');
  const triggerText = document.getElementById('statusFilterTriggerText');
  const labels = { ALL: 'すべて', NEW: '新作', LIMITED: '限定' };
  if (triggerText) triggerText.innerText = labels[currentStatus] || 'すべて';
  if (trigger) trigger.classList.toggle('is-active', currentStatus !== 'ALL');
  document.querySelectorAll('#statusSheetList .status-option').forEach(option => {
    option.classList.toggle('is-selected', option.getAttribute('onclick')?.includes(`'${currentStatus}'`));
  });
}

function renderCatalogGrid() {
  const catalogProducts = window.WWJF_CATALOG_PRODUCTS || [];
  const grid = document.getElementById('catalogGrid');
  currentItems = catalogProducts.filter(p => {
    const matchesCategory = p.category === currentCategory;
    const matchesBrand = currentBrand === 'ALL' || p.brand === currentBrand;
    const matchesStatus = currentStatus === 'ALL' || (currentStatus === 'NEW' && p.isNew === true) || (currentStatus === 'LIMITED' && Boolean(p.limitedText));
    return matchesCategory && matchesBrand && matchesStatus;
  });
  currentPage = 0;
  grid.innerHTML = '';
  const old = document.getElementById('scroll-sentinel');
  if (old) old.remove();
  if (currentItems.length === 0) { grid.innerHTML = '<p class="catalog-empty">該当する商品が見つかりませんでした。</p>'; return; }
  loadMoreItems();
}

function loadMoreItems() {
  // Loading表示を削除
  const loading = document.getElementById('scroll-loading');
  if (loading) loading.remove();

  const grid = document.getElementById('catalogGrid');
  const start = currentPage * PAGE_SIZE;
  const pageItems = currentItems.slice(start, start + PAGE_SIZE);

  pageItems.forEach(p => {
    const item = db[p.id];
    if (!item) return;
    const liked = wishlist.has(p.id) ? 'is-liked' : '';

    const hasMultiPriceRange =
    item.isMultiModal &&
    Number(item.multiPriceMin) > 0 &&
    Number(item.multiPriceMax) > 0;

    const cardPrice = hasMultiPriceRange
  ? `${formatPrice(item.multiPriceMin)}～${formatPrice(item.multiPriceMax)}`
  : formatPrice(item.price);


    let badgesHtml = '';
    if (p.isNew || p.limitedText) {
      badgesHtml += `<div class="catalog-item__badges">`;
      if (p.isNew) badgesHtml += `<span class="catalog-item__badge catalog-item__badge--new">NEW</span>`;
      if (p.limitedText) badgesHtml += `<span class="catalog-item__badge catalog-item__badge--limited">${p.limitedText}</span>`;
      badgesHtml += `</div>`;
    }

    const div = document.createElement('div');
    div.className = 'catalog-item';
    div.dataset.category = p.category;
    div.dataset.brand = p.brand;
    div.style.opacity = '0';
    div.style.transform = 'translateY(16px)';
    div.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
    div.innerHTML = `
      <div class="catalog-item__media catalog-item__media--square" onclick="openWWJFProductModal('${p.id}')">
        <img src="${item.img}" alt="${item.brand} ${item.title}" loading="lazy">
        <button class="like-btn ${liked}" onclick="toggleLike(event,'${p.id}')"><svg width="16" height="16" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></button>
      </div>
      <div onclick="openWWJFProductModal('${p.id}')" style="cursor:pointer;">
        <p class="catalog-item__brand">${item.brand}</p>
        <h3 class="catalog-item__name">${item.title}</h3>
        ${item.isMultiModal && Number(item.multiPriceMin) === 0 && Number(item.multiPriceMax) === 0  ? ''  : `<p class="catalog-item__price">${cardPrice}<span class="catalog-item__price-unit">円<span class="catalog-item__price-tax">（税込）</span></span></p>`}
        ${badgesHtml}
      </div>`;
    grid.appendChild(div);

    // フェードイン
    requestAnimationFrame(() => requestAnimationFrame(() => {
      div.style.opacity = '1';
      div.style.transform = 'translateY(0)';
    }));
  });

  currentPage++;

  const old = document.getElementById('scroll-sentinel');
  if (old) old.remove();

  if (currentPage * PAGE_SIZE < currentItems.length) {
    // Now Loading表示
    const loading = document.createElement('p');
    loading.id = 'scroll-loading';
    loading.innerText = 'Now Loading...';
    loading.style.cssText = 'text-align:center; padding:24px; color:#999; font-size:12px; letter-spacing:0.1em;';

    const sentinel = document.createElement('div');
    sentinel.id = 'scroll-sentinel';
    sentinel.style.height = '1px';

    grid.after(loading);
    loading.after(sentinel);
    scrollObserver.observe(sentinel);
  }
}


function showToast(msg) {
  const toast = document.getElementById('toast');
  if (!toast) return;

  toast.innerText = msg;
  toast.classList.add('is-visible');

  setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3000);
}

// 現在のページにある商品データを取得
function getWWJFWishlistItem(id) {
  return (
    (window.db && window.db[id]) ||
    (window.WWJF_DB && window.WWJF_DB[id]) ||
    db[id] ||
    (window.wishlistData && window.wishlistData[id]) ||
    null
  );
}

// IDと商品データを両方保存
function saveWWJFWishlist() {
  try {
    localStorage.setItem(
      'wwjf_wishlist',
      JSON.stringify([...window.wishlist])
    );

    localStorage.setItem(
      'wwjf_wishlist_data',
      JSON.stringify(window.wishlistData || {})
    );
  } catch (e) {
    console.warn('[WWJF] お気に入りを保存できませんでした', e);
  }
}

// お気に入り欄の価格表示
function formatWWJFWishlistPrice(item) {
  const formatAmount = raw => {
    const digits = String(raw ?? '').replace(/[^0-9]/g, '');
    return digits ? Number(digits).toLocaleString('ja-JP') : '';
  };

  if (item.isMultiModal) {
    const min = Number(item.multiPriceMin);
    const max = Number(item.multiPriceMax);

    if (min > 0 && max > 0) {
      return `￥${formatAmount(min)}～￥${formatAmount(max)}(税込)`;
    }

    if (min === 0 && max === 0) {
      return '';
    }
  }

  const amount = formatAmount(item.price);
  return amount ? `￥${amount}(税込)` : '';
}

// 商品テキストをHTML表示用に変換
function escapeWWJFWishlistHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, character => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[character]));
}

function toggleLike(e, id) {
  if (e) e.stopPropagation();

  const favorites = window.wishlist;
  const isLiked = favorites.has(id);

  window.wishlistData = window.wishlistData || {};

  if (isLiked) {
    favorites.delete(id);
    delete window.wishlistData[id];
    showToast('リストから削除しました');
  } else {
    favorites.add(id);

    const item = getWWJFWishlistItem(id);

    if (item) {
      window.wishlistData[id] = item;
    }

    showToast('気になるリストに追加しました');
  }

  saveWWJFWishlist();

  document.querySelectorAll('.like-btn[onclick]').forEach(btn => {
    const onclick = btn.getAttribute('onclick') || '';

    if (
      onclick.includes(`'${id}'`) ||
      onclick.includes(`"${id}"`)
    ) {
      btn.classList.toggle('is-liked', !isLiked);
    }
  });

  const countBadge = document.getElementById('headerCount');

  if (countBadge) {
    countBadge.innerText = favorites.size;
    countBadge.classList.toggle('is-hidden', favorites.size === 0);
  }

  if (
    currentModalId === id &&
    typeof updateModalButtonState === 'function'
  ) {
    updateModalButtonState();
  }

  renderDrawerItems();
}

/* 通常モーダルへ中継 */
window.openProductModal = function(id) {
  if (typeof window.openWWJFDefaultProductModal === 'function') {
    return window.openWWJFDefaultProductModal(id);
  }

  console.warn('[WWJF] 通常モーダルがまだ読み込まれていません');
};

function openDrawer() {
  renderDrawerItems();

  const overlay = document.getElementById('drawerOverlay');
  const panel = document.getElementById('drawerPanel');

  if (!overlay || !panel) return;

  overlay.classList.add('is-open');
  void overlay.offsetWidth;
  panel.classList.add('is-open');
}

function closeDrawer() {
  const overlay = document.getElementById('drawerOverlay');
  const panel = document.getElementById('drawerPanel');

  if (panel) {
    panel.classList.remove('is-open');
  }

  if (overlay) {
    setTimeout(() => {
      overlay.classList.remove('is-open');
    }, 300);
  }
}

function renderDrawerItems() {
  const container = document.getElementById('drawerList');
  if (!container) return;

  const favorites = window.wishlist;
  window.wishlistData = window.wishlistData || {};

  if (favorites.size === 0) {
    container.innerHTML = `
      <p class="drawer-list__empty">
        リストは空です。<br>
        ♡アイコンをタップして商品を追加してください。
      </p>
    `;
    return;
  }

  container.innerHTML = '';
  const list = document.createElement('div');
  list.className = 'drawer-list__items';

  favorites.forEach(id => {
    const item = getWWJFWishlistItem(id);
    if (!item) return;

    // 今のページに商品があれば保存データを更新
    window.wishlistData[id] = item;

    const price = formatWWJFWishlistPrice(item);
    const row = document.createElement('div');
    row.className = 'drawer-item';

    row.innerHTML = `
      <div class="drawer-item__media">
        <img src="${escapeWWJFWishlistHtml(item.img)}" alt="">
      </div>
      <div class="drawer-item__info">
        <p class="drawer-item__brand">
          ${escapeWWJFWishlistHtml(item.brand)}
        </p>
        <h4 class="drawer-item__name">
          ${escapeWWJFWishlistHtml(item.title)}
        </h4>
        <div class="drawer-item__bottom">
          <p class="drawer-item__price">
            ${escapeWWJFWishlistHtml(price)}
          </p>
          <button
            type="button"
            class="drawer-item__remove"
            aria-label="気になるリストから削除"
          >&times;</button>
        </div>
      </div>
    `;

    row.addEventListener('click', () => {
      if (typeof openWWJFProductModal === 'function') {
        openWWJFProductModal(id);
      }
    });

    row.querySelector('.drawer-item__remove')
      .addEventListener('click', event => {
        toggleLike(event, id);
      });

    list.appendChild(row);
  });

  container.appendChild(list);
  saveWWJFWishlist();
}
